import { Core } from 'chessboard/core/config/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { StateMachine } from 'chessboard/core/state/config/types';

export const addingMarkings = {
  anyAPIEvent: ({ UpdateParams }: { UpdateParams: StateMachine.UpdateParams }) => {
    UpdateParams.cancelMarkingStartSquare();

    return StateMachine.States.Idle;
  },

  [Core.UserEvents.PointerdownLeft]: ({
    UpdateParams,
  }: {
    UpdateParams: StateMachine.UpdateParams;
  }) => {
    UpdateParams.cancelMarkingStartSquare();

    return StateMachine.States.Idle;
  },

  [Core.UserEvents.Pointerup]: ({
    context,
    data: { keyPressed, square },
    params: { markingStartSquare },
    UpdateParams,
  }: StateMachine.TransitionParams) => {
    const {
      api: { markings },
      queue,
    } = context;

    if (square && markingStartSquare) {
      const markingPayload =
        markingStartSquare === square
          ? (<Markings.API>markings).factory.buildStandardAnalysisHighlight(square, keyPressed)
          : (<Markings.API>markings).factory.buildStandardArrow(
              markingStartSquare,
              square,
              keyPressed,
            );

      queue.add((<Markings.API>markings).toggleOne, markingPayload);
    }

    UpdateParams.cancelMarkingStartSquare();

    return StateMachine.States.Idle;
  },
};
